import type { TThemeListTab } from './theme-list-tab.types'
import { GlobalTopicsTableView } from '../global-topics-table'

export const ThemeListTabView = ({
  data,
  error,
  handleSetOrder,
  isLoading,
  order,
  refetch,
  totalCount,
}: TThemeListTab) => {
  return (
    <GlobalTopicsTableView
      data={data}
      error={error}
      handleSetOrder={handleSetOrder}
      hasMore={false}
      isFetchingMore={false}
      isLoading={isLoading}
      refetch={refetch}
      totalCount={totalCount}
      order={order}
      sentryRef={null}
      isZaiReportColumnVisible={false}
    />
  )
}
